import { publishPresentationMutation } from '../graphql/mutations';
import { createSelector } from 'reselect';
import localforage from 'localforage';
import utils from '../utils';
import { savePresentationUpdates } from '../../editor/actions/firebaseObjectActions';
import { buildPresentationVersion } from '../../editor/actions/presentationActions';
import { database } from '../firebase';
import { ref, get, child } from 'firebase/database';

const selectSlides = state => state.slides;
const selectOrder = state => state.order;

const getOrder = createSelector([selectSlides, selectOrder], (slides, order) =>
  utils.intersection([
    order,
    Object.values(slides)
      .filter(slide => slide && slide.visible !== false)
      .map(slide => slide.id),
  ]),
);

export const publishPresentation = id => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    dispatch({ type: 'PUBLISH_PRESENTATION', id });
    let thumbnail;
    if (window.app === 'editor') {
      const contentState = getState().contentReducer;
      const orderForVisibleSlides = getOrder(contentState.presentation);
      const firstThumbnail = getState().thumbnailsReducer.generated[
        orderForVisibleSlides[0]
      ];
      thumbnail = firstThumbnail ? firstThumbnail.imageData : null;
    } else if (window.app === 'viewer') {
      thumbnail = getState().slideReducer.thumbnail;
    } else {
      thumbnail = '';
    }

    new Promise((resolve, reject) => {
      if (window.app !== 'editor') {
        const presentationRef = ref(database);
        get(child(presentationRef, 'presentations/' + id)).then(snapshot => {
          const presentation = snapshot.val();
          const { version, updatedSlideVersion } = buildPresentationVersion(
            presentation,
          );
          const updates = {
            [`/presentations/${id}/published_version`]: version,
            [`/presentations/${id}/version`]: version,
          };
          Object.entries(updatedSlideVersion).forEach(([slideId, version]) => {
            updates[`/presentations/${id}/slides/${slideId}/version`] = version;
          });
          savePresentationUpdates(updates).then(resolve);
          const image = new Image();
          image.src = `/${id}/thumbnail?draft=1&d=${presentation.updated_at ||
            presentation.updatedAt}`;
          image.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = image.width;
            canvas.height = image.height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0);
            const dataURL = canvas.toDataURL('image/png');
            thumbnail = dataURL;
            resolve();
          };
        });
      } else if (window.app === 'editor') {
        const contentState = getState().contentReducer;

        const { version, updatedSlideVersion } = buildPresentationVersion(
          contentState.presentation,
        );
        const updates = {
          [`/presentations/${id}/published_version`]: version,
          [`/presentations/${id}/version`]: version,
        };
        Object.entries(updatedSlideVersion).forEach(([slideId, version]) => {
          updates[`/presentations/${id}/slides/${slideId}/version`] = version;
        });
        savePresentationUpdates(updates)
          .then(resolve)
          .catch(reject);
      } else {
        resolve();
      }
    })
      .then(() => {
        publishPresentationMutation(id, thumbnail)
          .then(({ data }) => {
            const { success } = data.publishPresentation;
            if (!success) {
              reject();
            } else {
              dispatch(dispatchPublishedPresentation(id));
              resolve();
            }
          })
          .catch(reject);
      })
      .catch(e => {
        const updates = {
          [`/presentations/${id}/published_version`]: null,
        };
        savePresentationUpdates(updates);
        reject(e.message);
      });
  });
};

export const dispatchPublishedPresentation = presentationId => dispatch => {
  const publishedAt = Date.now();
  localforage.setItem(presentationId, { publishedAt }, () => {
    localStorage.setItem(
      'draftDataUpdated',
      JSON.stringify({ presentationId, time: Date.now() }),
    );
  });
  dispatch({ type: 'PUBLISHED_PRESENTATION', publishedAt });
};

export const refreshPresentationFromLS = presentation => ({
  type: 'PRESENTATIONS_REFRESHED_FROM_LOCALSTORAGE',
  presentation,
});
